<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Contratos" :content="meta.total" icon="file-contract" />
      <sys-widget title="Monto de inversión" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import contractService from '@/services/contracts'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'

export default {
  name: 'Contracts',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Contratos',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Folio', value: 'folio' },
        { text: 'Acreedor', value: 'investor_name' },
        { text: 'Monto de inversión', value: 'amount', filter: formatCurrency },
        { text: 'Anexos activos', value: 'attachments_count' },
        { text: 'Corte', value: 'cut_day' },
        { text: 'Tasa', value: 'interest_rate' },
        { text: 'Tipo de Tasa', value: 'rate_type' },
        { text: 'Frecuencia', value: 'frequency' },
        { text: 'Tipo', value: 'type' }
      ],
      items: [],
      filtered_items: [],
      items_sum: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'contract',
      create_route: 'contract_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'investor_name',
          name: 'Acreedor',
          hint: 'Acreedor',
          icon: 'user',
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.investor_name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'folio',
          name: 'Folio contrato',
          hint: 'Folio contrato',
          icon: 'file-contract',
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.folio.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'type',
          name: 'Tipo',
          hint: 'Todos',
          icon: 'list',
          type: 'select',
          value: '',
          options: [],
          size: 4,
          validator: (item, value) => item.type == value
        },
        {
          id: 'amount',
          name: 'Monto de inversión desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 4,
          value: '',
          validator: (item, value) => item.total_investment >= value
        },
        {
          id: 'investment_to',
          name: 'Monto de inversión hasta (en anexos)',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 4,
          value: '',
          validator: (item, value) => item.total_investment <= value
        },
        {
          id: 'cut_day',
          name: 'Día de corte',
          hint: 'Todos',
          icon: 'calendar-alt',
          type: 'select',
          value: '',
          options: [
            { value: '7', text: '7' },
            { value: '15', text: '15' },
            { value: '21', text: '21' },
            { value: 'last_day', text: 'Último de mes' }
          ],
          size: 4,
          validator: (item, value) => item.cut_day == value
        }
      ]
    }
  },
  beforeCreate: function () {
    contractService.getTypes().then(res => {
      this.contract_types = res.data.map(data => {
        return { value: data.name, text: `${data.name} (${data.code})` }
      })
      this.filters[2].options = this.contract_types
    }).catch(err => {
      console.log(JSON.stringify(err))
    })
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      contractService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contracts/Contracts.vue